import { Dispatch, RefObject, SetStateAction, useEffect, useRef } from "react";
import { Platform, StyleProp, StyleSheet, View, ViewStyle } from "react-native";
import DropDownPicker from "react-native-dropdown-picker";

import CustomText from "../../general/CustomText/CustomText";

interface FilterDropdownProps {
  filterValue: string;
  setFilterValue: Dispatch<SetStateAction<string>>;
  filterDropdownOpen: boolean;
  setFilterDropdownOpen: Dispatch<SetStateAction<boolean>>;
  filterItems: { label: string; value: string }[];
  label?: string;
  customStyle?: StyleProp<ViewStyle>;
  placeholder?: string;
  fullWidth?: boolean;
}

const FilterDropdown = ({
  filterValue,
  setFilterValue,
  filterDropdownOpen,
  setFilterDropdownOpen,
  filterItems,
  label,
  customStyle = {},
  placeholder,
  fullWidth = false,
}: FilterDropdownProps) => {
  const ref = useRef(null);

  useEffect(() => {
    if (Platform.OS === "web" && filterDropdownOpen) {
      const handleClickOutside = (event) => {
        const catchClick = ref.current?.contains?.(event.target);
        if (!catchClick) {
          setFilterDropdownOpen(false);
        }
      };
      document.addEventListener("click", handleClickOutside);
      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    }
  }, [filterDropdownOpen, setFilterDropdownOpen, ref]);

  return (
    <View style={styles.filterContainer} ref={ref as unknown as RefObject<View>} id={`${label || "filter"}-dropdown`}>
      {label && <CustomText size="s" style={[styles.filterLabel, customStyle]} text={label} />}
      <DropDownPicker
        open={filterDropdownOpen}
        value={filterValue}
        items={filterItems}
        setOpen={(value) => setFilterDropdownOpen(value)}
        setValue={setFilterValue}
        dropDownContainerStyle={[styles.dropdownContainer, fullWidth && styles.dropdownContainerFullWidth]}
        style={[styles.dropdownField, fullWidth && styles.dropdownFieldFullWidth]}
        textStyle={styles.dropdownText}
        placeholder={placeholder}
        zIndex={3000}
        onSelectItem={() => setFilterDropdownOpen(false)}
        onClose={() => setFilterDropdownOpen(false)}
        onChangeValue={(value) => {
          setFilterValue(value || "");
          setFilterDropdownOpen(false);
        }}
      />
    </View>
  );
};

export default FilterDropdown;

const styles = StyleSheet.create({
  filterContainer: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: 8,
    zIndex: 3000,
    elevation: 3000,
  },
  filterLabel: {
    color: "#667085",
    // minWidth: 50,
    marginRight: 8,
    display: "flex",
    flexWrap: "nowrap",
    flexShrink: 0,
  },
  dropdownContainer: {
    width: 174,
    borderColor: "rgb(229, 231, 235)",
    backgroundColor: "white",
    zIndex: 3000,
    elevation: 3000,
  },
  dropdownField: {
    width: 174,
    borderColor: "rgb(229, 231, 235)",
    zIndex: 3000,
    elevation: 3000,
    minHeight: 42.5,
    backgroundColor: "white",
    borderRadius: 6,
    borderWidth: 1,
  },
  dropdownText: {
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "500",
    color: "#344054",
  },
  dropdownContainerFullWidth: {
    width: "100%",
  },
  dropdownFieldFullWidth: {
    width: "100%",
  },
});
